import React from 'react';

import classes from './periodSelector.module.scss';

const PeriodSelector = ({period, setPeriod, data}) => {
  
    const formatSaving = (saving) => {
        const num = parseInt(saving);
        if (!isNaN(num) && num >= 1000) {
            return `${Math.floor(num / 1000)}k`;
        }
        return num;
    };

    return (
        <div className={period === 'Monthly' ? `${classes['tab']} ${classes['left']}` : `${classes['tab']} ${classes['right']}`}>
            <div className={period === 'Monthly' ? classes['selected'] : ''} onClick={() => setPeriod('Monthly')}>
                Monthly
            </div>
            <div className={period === 'Annual' ? classes['selected'] : ''} onClick={() => setPeriod('Annual')}>
                Annual (save {data?.currency?.symbol}{formatSaving(data?.saving)})
            </div>
        </div>
    );
};

export default PeriodSelector;